import { PanelType } from "../Panel/PanelTypes";

export function hiddenPanelTestPageObject(
    onPanelStateChange: undefined | ((panelState: PanelType) => void),
    panelState: "pin" | "show" | "hide" | "pinManual" | "hideManual",
    handleMouseOver: () => void | undefined
) {
    return {
        getType: () => "HiddenPanel",

        hide: (prop?: "Manual"): void => {
            if (prop === "Manual") {
                onPanelStateChange?.(`hideManual`);
            } else {
                onPanelStateChange?.(`hide`);
            }
        },

        show: () => {
            onPanelStateChange?.("show");
        },

        isHidden: (): boolean => !(panelState === "show" || panelState === "pin" || panelState === "pinManual"),

        pin: (prop?: "Manual"): void => {
            if (prop === "Manual") {
                onPanelStateChange?.(`pinManual`);
            } else {
                onPanelStateChange?.(`pin`);
            }
        },

        mouseEnter: (): void => {
            handleMouseOver();
        },

        getState: (): PanelType => panelState,
    };
}
